// import {
//     FacebookLoginProvider,
//     GoogleLoginProvider,
//     SocialAuthServiceConfig,
//     SocialLoginModule,
// } from '@abacritt/angularx-social-login';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthModule } from '@klickdata/core/auth';
import { FormModule } from '@klickdata/core/form';
import { HttpModule } from '@klickdata/core/http';
import { MessageModule } from '@klickdata/core/message';
import { ActivateComponent } from '@klickdata/guest/src/activate/activate.component';
import { ActivationService } from '@klickdata/guest/src/activate/activation.service';
import { ForgetPasswordComponent } from '@klickdata/guest/src/forget-password/forget-password.component';
import { PasswordService } from '@klickdata/guest/src/forget-password/password.service';
import { GuestRoutingModule } from '@klickdata/guest/src/guest-routing.module';
import { GuestComponent } from '@klickdata/guest/src/guest.component';
import { DevicesDialogComponent } from '@klickdata/guest/src/login/devices-dialog/devices-dialog.component';
import { LoginComponent } from '@klickdata/guest/src/login/login.component';
import { ResetPasswordComponent } from '@klickdata/guest/src/reset-password/reset-password.component';
import { ContactDialogComponent } from '@klickdata/guest/src/start/contact-dialog/contact-dialog.component';
import { StartComponent } from '@klickdata/guest/src/start/start.component';
import { TrialComponent } from '@klickdata/guest/src/trial/trial.component';
import { KdLoaderModule } from '@klickdata/kd-loader';
import { MaterialModule } from '@klickdata/material';
import { SharedComponentsModule } from '@klickdata/shared-components';
import { PipesModule } from 'apps/klickdata/src/app/shared/pipes/pipes.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LocalizationModule } from './../../core/localization/src/localization.module';
import { AcademySelectComponent } from './academy-select/academy-select.component';
import { ChatIoPaymentManagerComponent } from './chat-io/chat-io-payment/chat-io-payment-manager/chat-io-payment-manager.component';
import { ChatIoPaymentComponent } from './chat-io/chat-io-payment/chat-io-payment.component';
import { AdeccoLoginComponent } from './login/customer/adecco-login/adecco-login.component';
import { KlickdataLoginComponent } from './login/customer/klickdata-login/klickdata-login.component';
import { PicoLoginComponent } from './login/customer/pico-login/pico-login.component';
import { PolfarsktLoginComponent } from './login/customer/polfarskt-login/polfarskt-login.component';
import { StudentconsultingLoginComponent } from './login/customer/studentconsulting-login/studentconsulting-login.component';
import { WokacademyLoginComponent } from './login/customer/wokacademy-login/wokacademy-login.component';
import { LoginFormComponent } from './login/login-form/login-form.component';
import { OnBoardingComponent } from './on-boarding/on-boarding.component';
import { GuestModeHeaderComponent } from './onboarding-guest-mode/guest-mode-header/guest-mode-header.component';
import { GuestModeLoginComponent } from './onboarding-guest-mode/guest-mode-login/guest-mode-login.component';
import { GuestModeMobileLoginComponent } from './onboarding-guest-mode/guest-mode-mobile-login/guest-mode-mobile-login.component';
import { GuestModeSectionsComponent } from './onboarding-guest-mode/guest-mode-sections/guest-mode-sections.component';
import { OnboardingGuestModeComponent } from './onboarding-guest-mode/onboarding-guest-mode.component';
import { SignupFormComponent } from './signup/signup-form/signup-form.component';
import { SignupComponent } from './signup/signup.component';
import { SocialLoginComponent } from './social-login/social-login.component';
@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FlexLayoutModule,
        LocalizationModule,

        // Klickdata core modules
        HttpModule,
        AuthModule,
        MessageModule,
        FormModule,

        // Klickdata shared modules
        MaterialModule,
        SharedComponentsModule,

        // Local modules
        GuestRoutingModule,
        // SocialLoginModule,
        InfiniteScrollModule,
        PipesModule,
        KdLoaderModule,
        MatPasswordStrengthModule,
    ],
    providers: [
        ActivationService,
        PasswordService,
        // {
        //     provide: 'SocialAuthServiceConfig',
        //     useValue: {
        //         autoLogin: false,
        //         providers: [
        //             {
        //                 id: GoogleLoginProvider.PROVIDER_ID,
        //                 provider: new GoogleLoginProvider(GOOGLE_CLIENT_ID),
        //             },
        //             {
        //                 id: FacebookLoginProvider.PROVIDER_ID,
        //                 provider: new FacebookLoginProvider(FACEBOOK_CLIENT_ID),
        //             },
        //         ],
        //     } as SocialAuthServiceConfig,
        // },
        {
            provide: MatDialogRef,
            useValue: {},
        },
    ],
    exports: [GuestComponent],
    declarations: [
        GuestComponent,
        LoginComponent,
        LoginFormComponent,
        TrialComponent,
        ForgetPasswordComponent,
        ResetPasswordComponent,
        ContactDialogComponent,
        DevicesDialogComponent,
        StartComponent,
        ActivateComponent,
        KlickdataLoginComponent,
        AdeccoLoginComponent,
        PolfarsktLoginComponent,
        StudentconsultingLoginComponent,
        PicoLoginComponent,
        WokacademyLoginComponent,
        AcademySelectComponent,
        OnBoardingComponent,
        SignupComponent,
        SignupFormComponent,
        SocialLoginComponent,
        ChatIoPaymentComponent,
        ChatIoPaymentManagerComponent,
        OnboardingGuestModeComponent,
        GuestModeHeaderComponent,
        GuestModeSectionsComponent,
        GuestModeLoginComponent,
        GuestModeMobileLoginComponent,
    ],
})
export class GuestModule {}
